/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = () => css`
  width: inherit;
  height: auto;

  .fill {
    fill: inherit;
  }
`

export default function ArrowIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="72.589" height="40" viewBox="0 0 72.589 40" css={Color}
         className="arrow-svg">
      <path id="arrowIco" className="fill" data-name="빼기 68"
            d="M37.795,41.5a3.683,3.683,0,0,1-2.622-1.084l-.017-.017-.017-.017L2.586,7.83A3.708,3.708,0,0,1,7.83,2.587L36.662,31.419a1.6,1.6,0,0,0,2.26,0L67.757,2.587A3.709,3.709,0,0,1,73,7.832L40.417,40.416A3.683,3.683,0,0,1,37.795,41.5Z"
            transform="translate(-1.5 -1.5)" fill="#eee"/>
    </svg>
  )
}
